import React, { Component } from "react";
import "./GridCars.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CarModel from "../CarModel/CarModel";
import { isMobile } from "react-device-detect";
import { fetchAutos } from "../../actions/cars";
import store from "../../store";
import Navbar from "../Navbar/Navbar";

class gridCars extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: "COROLLA",
      models: []
    };
  }

  componentDidMount = () => {
    store.dispatch(fetchAutos()).then(() => this.fillAutos());
  };

  fillAutos = () => {
    console.log("FILL AUTOS" + store.getState().carsReducer.autos);
    this.setState({ models: store.getState().carsReducer.autos });
  };

  handleChange = event => {
    console.log(event.target.id);
    this.setState({ selected: event.target.id });
    //this.setProps({ selectedModel: event.target.id });
  };

  handleSelection = model => {
    this.setState({ selected: model });
  };

  render() {
    return (
      <React.Fragment>
        <Navbar
          onClick={this.props.playVideoHander}
          handleSelection={this.handleSelection}
        />

        <Grid container className={isMobile ? "GridCarMobile" : "GridCarWeb"}>
          <Grid item xs={12} sm={12}>
            <div className={isMobile ? "TitleMobile" : "Title"}>
              Elegí tu próximo modelo, ¡0KM, cero vueltas!
            </div>
            <div className="Title-middle">
              Todos los modelos están disponibles, listos para ser patentados.
              ¡Reservá el tuyo ahora!
            </div>
          </Grid>

          <Grid item xs={12} className="ModelButtons">
            <div
              id="COROLLA"
              onClick={this.handleChange}
              className={
                this.state.selected === "COROLLA"
                  ? "ModelButtonSelected"
                  : "ModelButton"
              }
            >
              COROLLA
            </div>
            <div
              id="ETIOS"
              onClick={this.handleChange}
              className={
                this.state.selected === "ETIOS"
                  ? "ModelButtonSelected"
                  : "ModelButton"
              }
            >
              ETIOS
            </div>

            <div
              id="YARIS"
              onClick={this.handleChange}
              className={
                this.state.selected === "YARIS"
                  ? "ModelButtonSelected"
                  : "ModelButton"
              }
            >
              YARIS
            </div>
            {isMobile ? (
              <div className="DivButtons">
                <br />
              </div>
            ) : null}
            <div
              id="HILUX"
              onClick={this.handleChange}
              className={
                this.state.selected === "HILUX"
                  ? "ModelButtonSelected"
                  : "ModelButton"
              }
            >
              HILUX
            </div>
            <div
              id="SW4"
              onClick={this.handleChange}
              className={
                this.state.selected === "SW4"
                  ? "ModelButtonSelected"
                  : "ModelButton"
              }
            >
              SW4
            </div>
            <div
              id="RAV4"
              onClick={this.handleChange}
              className={
                this.state.selected === "RAV4"
                  ? "ModelButtonSelected"
                  : "ModelButton"
              }
            >
              RAV4
            </div>
          </Grid>

          <Grid item xs={12}>
            {this.state.models.map(model =>
              model.modelo === this.state.selected ? (
                <CarModel name={model.modelo} />
              ) : null
            )}
          </Grid>
          <Grid item xs={12}>
            <div className="CarModelDesc">
              Precios válidos únicamente para realizar una reserva online y de
              contado. Exenta está la posibilidad de financiación y/o permuta.{" "}
              <br />
              Para más información XXXX-XXXX o consultas@prana.com.ar
            </div>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default gridCars;
